import NAMESPACE from './types';

export function selectAppStateSlice(appState) {
    return appState[NAMESPACE];
}
